import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ConstantsHelper } from 'src/assets/constants/constants.helper';
import { HelperService, AuthService } from 'src/app/services';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MediaObserver } from '@angular/flex-layout';
import { debounceTime, map } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  selector: 'esc-maintenance-list',
  templateUrl: './maintenance-list.component.html',
  styleUrls: ['./maintenance-list.component.scss']
})
export class MaintenanceListComponent implements OnInit {
  @Input() list;
  @Input() columns;
  @Input() uploadColumns;
  @Input() uploadTemplateColumns; //only used for group maintenance
  @Input() uploadTemplateColumns2; //only used for group maintenance
  @Input() loading;
  @Input() loadError;
  @Input() recordCount;
  @Input() deselect;
  @Input() type;
  @Input() hasFilter;
  @Input() moduleCode;
  @Input() folderName;
  @Input() folderName2; //only used for group maintenance
  @Input() hasUpload;
  @Input() hasDownload;
  @Input() hasDlSubMenu;
  @Input() hasUlSubMenu;
  @Input() hasQrBulkDownload;
  @Input() hasCouponBulkDownload;
  @Input() modifying: Boolean = false;
  @Output() addNew = new EventEmitter;
  @Output() getMore = new EventEmitter;
  @Output() refresh = new EventEmitter;
  @Output() searchBy = new EventEmitter;
  @Output() openFilter = new EventEmitter;
  @Output() download = new EventEmitter;
  @Output() getDetailData = new EventEmitter;
  @Output() qrBulkDownload = new EventEmitter;
  @Output() couponBulkDownload = new EventEmitter;

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    public authService: AuthService,
    ) {}

  public listData = [];
  public listLength = 0;
  public form: FormGroup;
  public filterNumber;
  public selectedData;
  public displayedColumns;
  public constants = ConstantsHelper;

  ngOnInit() {
    this.initForm();
    this.displayedColumns = this.columns;
    this.listData = _.clone(this.list);
    this.search();
  }

  initForm() {
    this.form = this.fb.group({
      searchTerm: [null],
    });
  }

  getDetail(selectedData) {
    if (this.selectedData != selectedData) {
      this.getDetailData.next(selectedData);
      this.selectedData = selectedData;
    }
  }

  getMoreData() {
    this.getMore.next(true);
  }

  add() {
    this.addNew.next(true);
  }

  refreshList() {
    this.refresh.next(null);
  }

  filterList() {
    this.openFilter.next(true);
  }

  search() {
    this.form.get('searchTerm').valueChanges.pipe(
      debounceTime(600),
      // distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    ).subscribe((term) => {
      this.searchBy.next(term);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (_.get(changes, 'list') && changes.list.currentValue) {
      this.listData = _.clone(changes.list.currentValue);
    }

    if (_.get(changes, 'modifying') && changes.modifying.currentValue) {
      this.modifying = _.clone(changes.modifying.currentValue);
    }

    if (_.get(changes, 'deselect') && changes.deselect.currentValue) {
      this.selectedData = null;
    }

    if (this.modifying) {
      this.form.get('searchTerm').disable({ emitEvent: false });
    }

    if (!this.modifying && (_.get(this, 'form') && this.form.get('searchTerm').disabled)) {
      this.form.get('searchTerm').enable({ emitEvent: false });
    }
  }

  exportXlsx(mode) {
    if(!mode) {
      this.download.next(true);
    }
    else {
      this.download.next(mode);
    }
  }

  qrBulkDownloadSelected() {
    this.qrBulkDownload.next(true);
  }

  couponBulkDownloadSelected(groupingType) {
    this.couponBulkDownload.next(groupingType);
  }
}
